<template>
  <v-container class="py-10">
    <!-- Título -->
    <v-row justify="center" class="mb-6">
      <v-col cols="12" md="8" class="text-center">
        <h2 class="display-1 font-weight-bold">Nueva consulta de Empresas</h2>
        <p class="subtitle-1 grey--text">
          Valida los datos de la persona moral que deseas consultar.
        </p>
      </v-col>
    </v-row>

    <!-- Formulario -->
    <v-form ref="form" v-model="valid" v-if="!bLoading">
      <v-card class="pa-6 mx-auto" style="box-shadow: 0 4px 12px rgba(0, 0, 0, 0.38); border-radius: 16px;">
        <v-row>
          <!-- LADO IZQUIERDO - CONTEXTO -->
          <v-col cols="12" md="6">
            <div class="context-info pa-4">
              <h3 class="mb-2" style="font-family: 'montserrat-bold'; font-size: 18px;">
                Ingresa los siguientes datos para realizar la búsqueda:
              </h3>
              <v-divider class="my-4"></v-divider>
              <p><strong>Instrucciones para Generar un Reporte de Empresas</strong></p>

              <p class="mb-2" style="font-family: 'montserrat-semibold';"><strong>Paso 1: Ingresar la razón social de la empresa a consultar</strong></p>
              <ul>
                <li>
                  <span style="color: #e53935;">Es importante omitir el régimen de capital en la razón social.</span>
                </li>
              </ul>

              <p class="my-2 mt-3" style="font-family: 'montserrat-semibold';"><strong>Paso 2: Ingresar los datos opcionales</strong></p>
              <ul style="font-family: 'montserrat-semibold';">
                <li>RFC, marca, dominio web, comprobante de domicilio y constancia fiscal.</li>
                <li>Si omites alguno, el reporte se generará solo con la info disponible.</li>
                <li>Archivos deben pesar menos de 5 MB.</li>
              </ul>
            </div>
          </v-col>

          <!-- LADO DERECHO - FORMULARIO -->
          <v-col cols="12" md="6" style="display: flex; align-items: center;">
            <v-form>
              <v-row dense>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="form.razonSocial"
                    label="Razón Social*"
                    rounded
                    outlined
                    :rules="[rules.required]"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="form.rfc"
                    label="RFC"
                    rounded
                    outlined
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="form.nombreComercial"
                    label="Nombre comercial o Marca"
                    rounded
                    outlined
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="form.dominio"
                    label="Dominio de internet de la empresa*"
                    rounded
                    outlined
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-file-input
                    v-model="form.constanciaFiscal"
                    label="Constancia de Situación Fiscal"
                    rounded
                    outlined
                    hide-details
                    prepend-icon=""
                    prepend-inner-icon="mdi-cloud-upload"
                    accept=".pdf,.jpg,.jpeg,.png"
                    show-size
                    class="mb-6"
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-col>
        </v-row>
      </v-card>


      <v-row justify="center" class="mt-6">
        <v-btn color="white" class="mr-4" elevation="2" style="border: 2px solid #193D6E;" rounded @click="cancelar">
          <span class="font-weight-bold">Cancelar</span>
        </v-btn>
        <v-btn color="#193D6E" dark class="px-8 white--text" rounded @click="enviarFormularioEmpresa()">
          Siguiente
        </v-btn>
      </v-row>
    </v-form>
    <v-container v-else class="text-center">
      <v-progress-circular
        indeterminate
        color="primary"
        size="64"
      ></v-progress-circular>
      <p class="mt-4">Cargando...</p>
    </v-container>
  </v-container>
</template>

<script>
export default {
  name: 'ConsultaEmpresaForm',
  data() {
    return {
      valid: false,
      form: {
        razonSocial: '',
        rfc: '',
        nombreComercial: '',
        dominio: '',
        constanciaFiscal: null,
      },
      rules: {
        required: v => !!v || 'Este campo es obligatorio',
      },
    };
  },
  methods: {
    cancelar() {
      this.$router.push('/securityAgent');
    },
    submit() {
      if (this.$refs.form.validate()) {
        console.log('Datos válidos:', this.form);
        this.$router.push('/consulta/empresa/resultado');
      }
    },
    async enviarFormularioEmpresa() {
      if (this.$refs.form.validate()) {
        this.bLoading = true;
        try {
          const formData = new FormData();
          formData.append("razonSocial", this.form.razonSocial);
          formData.append("rfc", this.form.rfc);
          formData.append("marca", this.form.nombreComercial);
          formData.append("dominio", this.form.dominio);
          formData.append("constanciaFiscal", this.form.constanciaFiscal);

          const response = await DB.post(`${URI}/api/v1/${this.selectLanguage}/check/empresa/consultar`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: this.$store.state.sToken
                ? `Bearer ${this.$store.state.sToken}`
                : ""
            },
          });

          this.$router.push(`/reportEnterprise/${response.data.data.sId}`);
        } catch (error) {
          console.error("Error al enviar formulario:", error);
          this.mixError(error.response?.data?.message || "Ocurrió un error");
        } finally {
          this.bLoading = false;
        }
      }
    },
    convertFileToBase64(file) {
      return new Promise((resolve, reject) => {
        if (!file) return resolve(null);
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    }
  },
  computed: {
    selectLanguage: function () {
      return this.$store.state.language;
    },
  },
  watch: {
    selectLanguage: function () {
      if (this.selectLanguage) {
        this.texts = FILE.landing[this.selectLanguage];
      }
    },
  },
};
</script>
